export async function getproduct(props: any = {}, data = {}) {
    return await props.di.GET("connector/product/getProduct", data);
}

export async function saveproduct(props: any = {}, data = {}) {
    return await props.di.POST("connector/product/saveProduct", data);
}

export async function getproductattributes(props: any, data = {}) {
  return await props.di.POST('shopifyhome/request/getSingleAllAttrribute/', data)
  // return await props.di.POST('connector/product/getProductAttributes/', data) //DO NOT DELETE
}

export async function getcategoryttributes(props: any, data = {}) {
  return await props.di.POST('connector/profile/getCategoryAttributes/', data)
}

export async function searchcategory(props: any, data = {}) {
  return await props.di.POST('connector/profile/categorySearch/', data)
}